/**
 * Model-Master Utility Prompts
 *
 * General utility prompts for translation, analysis, summarization, and humanization.
 *
 * @module config/prompts/model-master-prompts
 */
// ═══════════════════════════════════════════════════════════════════════════
// MODEL-MASTER UTILITY PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const MODEL_MASTER_TRANSLATE = {
    id: 'MODEL_MASTER_TRANSLATE',
    name: 'Translation',
    description: 'Translate text to a target language',
    template: `Translate the following text to {{targetLanguage}}. Return only the translation, no explanation.

Text:
{{text}}`,
    requirements: {
        capabilities: [],
        temperature: 0.3,
        maxTokens: 4096,
    },
    version: 1,
    usedBy: ['model-master'],
};
export const MODEL_MASTER_ANALYZE = {
    id: 'MODEL_MASTER_ANALYZE',
    name: 'Text Analysis',
    description: 'Analyze text and provide structured output',
    template: `Analyze the following text. Provide structured analysis.

Text:
{{text}}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 2048,
    },
    version: 1,
    usedBy: ['model-master'],
};
export const MODEL_MASTER_SUMMARIZE = {
    id: 'MODEL_MASTER_SUMMARIZE',
    name: 'Summarization',
    description: 'Summarize text concisely',
    template: `Summarize the following text concisely.

Text:
{{text}}`,
    requirements: {
        capabilities: [],
        temperature: 0.4,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['model-master'],
};
export const MODEL_MASTER_DETECT_AI = {
    id: 'MODEL_MASTER_DETECT_AI',
    name: 'AI Detection',
    description: 'Detect AI-generated content indicators',
    template: `Analyze this text for AI-generated content indicators. Return a JSON object with probability (0-1) and evidence array.

Text:
{{text}}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.2,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['model-master'],
};
export const MODEL_MASTER_HUMANIZE = {
    id: 'MODEL_MASTER_HUMANIZE',
    name: 'Humanization',
    description: 'Rewrite text to sound more natural and human-like',
    template: `Rewrite this text to sound more natural and human-like while preserving the meaning.

Text:
{{text}}`,
    requirements: {
        capabilities: [],
        temperature: 0.7,
        maxTokens: 4096,
    },
    version: 1,
    usedBy: ['model-master'],
};
export const MODEL_MASTER_PROMPTS = [
    MODEL_MASTER_TRANSLATE,
    MODEL_MASTER_ANALYZE,
    MODEL_MASTER_SUMMARIZE,
    MODEL_MASTER_DETECT_AI,
    MODEL_MASTER_HUMANIZE,
];
//# sourceMappingURL=model-master-prompts.js.map